
import fieldMixin from "@/mixins/field"
import type { Field, WCaptcha } from "@/types/api/fields"

type F = Field<WCaptcha>

export default fieldMixin.extend({
  props: {
    field: {
      type: Object as VuePropType<F>,
      default: () => ({
        alias: "",
        title: { ru: "", en: "" },
        widget: {
          type: "captcha",
          options: {
            provider: "smartCaptcha",
            sitekey: "ysc1_bTdGbeEGdiHDc39tqgLrpYBxKKMP47nVb0bPB3xtf8b4dcbb",
            visible: true,
            help: { en: "", ru: "" },
            required: true,
          },
        },
        dataType: { type: "void", options: {} },
      }),
    },
  },

  data: () => ({
    script: null as HTMLScriptElement | null,
    loaded: false,
  }),

  computed: {
    sitekey (): F["widget"]["options"]["sitekey"] {
      return this.field.widget.options.sitekey || ""
    },
  },

  mounted () {
    // Для валидации
    this.$watch("model", async (model) => {
      const vp = this.$refs.validationProvider as any
      if (!vp) return
      const result = await vp.validate(model)
      vp.applyResult(result)
    }, { immediate: Boolean(this.model) })

    const unwatchLoaded = this.$watch("loaded", (loaded) => {
      const { sitekey } = this
      const container = this.$refs.container as Element

      if (
        !loaded ||
        !sitekey ||
        !container ||
        !window.smartCaptcha?.render
      ) return

      // https://cloud.yandex.ru/ru/docs/smartcaptcha/concepts/widget-methods#render
      window.smartCaptcha.render(container, {
        sitekey,
        callback: (token: string) => {
          this.model = token || undefined
        },
        hl: this.$i18n.locale,
      })

      unwatchLoaded()
    })

    this.$nuxt.$on("reset-captcha", () => {
      window.smartCaptcha?.reset()
      this.model = undefined
    })

    this.loadScript()
  },

  beforeDestroy () {
    try {
      window.smartCaptcha?.destroy?.()
    } catch (error) {
      console.error(error)
    }
    this.$nuxt.$off("reset-captcha")

    this.script?.remove()
    this.loaded = false
  },

  methods: {
    loadScript () {
      const script = document.createElement("script")
      script.src = "https://smartcaptcha.yandexcloud.net/captcha.js"
      script.onload = () => { this.loaded = true }
      script.defer = true
      this.script = script
      document.head.appendChild(script)
    },
  },
})
